import { render, staticRenderFns } from "./generalListSubcategory.vue?vue&type=template&id=d518c762"
import script from "./generalListSubcategory.vue?vue&type=script&lang=js"
export * from "./generalListSubcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports